import React, { useEffect, useRef, useState } from "react";
import { useDocumentTitle } from "../../hooks/customDocumentTitleHook";
import { useLocation, useNavigate } from "react-router-dom";
import { Gender, calculateAgeFromDOB, can_visit, exchangeDate, getPractice, notify } from "../../helpers";
import { fetchSingleSignoutPatient } from "../../services/patient";
// import { updateSignOutSheet } from "../../services/waitingRoom";
import Spacing from "../Spacing";
import html2pdf from "html2pdf.js";
import { RotateCw } from "lucide-react";
const maleAvatar = './images/avatar.png';
const femaleAvatar = './images/female.png';
const otherAvatar = './images/other.png';

export default function SignOutSheet() {
  const [filteredConditions, setFilteredConditions] = useState([]);
  const [signOutPatientData, setSignOutPatientData] = useState([]);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const navigate = useNavigate();
  const contentRef = useRef();
  const noteTextareaRef = useRef(null);
  const [noteText, setNoteText] = useState("");
  const [lastThreeVisitData, setLastThreeVisitData] = useState({});
  const [ancillaryServices, setAncillaryServices] = useState([]);
  const [lastWellnessDate, setLastWellnessDate] = useState("");
  const todayTextareaRef = useRef(null);
  const [todayText, setTodayText] = useState("");
  const [loadingText, setLoadingText] = useState(null);
  const [previsitDos, setPrevisitDos] = useState(null);
  const [enableRetry, setEnableRetry] = useState(false);
  const [disabledRetry, setDisabledRetry] = useState(false);
  const [retryPotentialAncillary, setRetryPotentialAncillary] = useState(false);
  let autoCallCount = 0;
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);


  const waitingId = queryParams.get('waiting_id');
  const sheetType = queryParams.get('type');
  const [accountId, setAccountId] = useState(getPractice("account_id"));
  const [locationId, setLocationId] = useState(getPractice("location_id"));

  useEffect(() => {
    if (locationId !== 0) return;

    const updatePracticeInfo = () => {
      const newAccountId = getPractice("account_id");
      const newLocationId = getPractice("location_id");
      if (newAccountId > 0 && newLocationId > 0) {
        setAccountId(newAccountId);
        setLocationId(newLocationId);
        return true;
      }
      return false;
    };

    if (!updatePracticeInfo()) {
      const updatePracticeInfoInterval = setInterval(() => {
        if (updatePracticeInfo()) clearInterval(updatePracticeInfoInterval);
      }, 500);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  useEffect(() => {
    if (noteTextareaRef.current) {
      noteTextareaRef.current.style.minHeight = "100px";
      noteTextareaRef.current.style.overflow = "hidden";
      noteTextareaRef.current.style.height = "auto";
      noteTextareaRef.current.style.height = noteTextareaRef.current.scrollHeight + "px";
    }
  }, [noteText]);

  useEffect(() => {
    if (todayTextareaRef.current) {
      todayTextareaRef.current.style.minHeight = "100px";
      todayTextareaRef.current.style.overflow = "hidden";
      todayTextareaRef.current.style.height = "auto";
      todayTextareaRef.current.style.height = todayTextareaRef.current.scrollHeight + "px";
    }
  }, [todayText]);

  useEffect(() => {
    if (locationId !== 0) {  
      if (waitingId !== null) {
        getSignOutPatient(accountId, locationId, waitingId);
        // if (waitingId !== "patient") {
        //   handleSignOutSheet(accountId, locationId, waitingId);
        // }
      } else {
        navigate(-1);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locationId, waitingId]);
  

  const getSignOutPatient = async (
    accountId,
    locationId,
    waitingRoomId,
    retry = false
  ) => {
    const response = await fetchSingleSignoutPatient(
      accountId,
      locationId,
      waitingRoomId,
      retry
    );
    if (response) {
      if (response.data === null) {
        window.close();
        return;
      }

      if (response?.data?.status === "success") {
        setSignOutPatientData(response?.data?.patient_data);
        setLastThreeVisitData(response?.data?.last_three_visits);
        setLastWellnessDate(response?.data?.last_annual_wellness_visit);
        setAncillaryServices(response?.data?.potential_ancillary_services);
        setPrevisitDos(response?.data?.dos);
        setIsDataLoaded(true);
        setRetryPotentialAncillary(false);

        if (
          response?.data?.patient_data?.chronic_conditions &&
          response?.data?.patient_data?.chronic_conditions.length > 0
        ) {
          handleFilterConditions(
            response?.data?.patient_data?.chronic_conditions
          );
        }

        if (
          response?.data?.patient_data?.chronic_conditions &&
          response?.data?.patient_data?.chronic_conditions.length > 0 &&
          (!response?.data?.potential_ancillary_services ||
            Object.keys(response?.data?.potential_ancillary_services).length ===
              0) &&
          autoCallCount <= 6
        ) {
          let retryBool = true;
          if (autoCallCount >= 1) {
            retryBool = false;
          }
          setRetryPotentialAncillary(true);

          await new Promise((resolve) => setTimeout(resolve, 5000)); // Wait for 5 seconds
          getSignOutPatient(accountId, locationId, waitingRoomId, retryBool);
          autoCallCount = autoCallCount + 1;
        }
      } else if (
        response?.data?.status === "inprogress" &&
        enableRetry === false
      ) {
        setLoadingText(response?.data?.message);
        setEnableRetry(response?.data?.reload_allowed);
        await new Promise((resolve) => setTimeout(resolve, 5000)); // Wait for 5 seconds        
        
        getSignOutPatient(
          accountId,
          locationId,
          waitingRoomId,
          response?.data?.auto_reload_allowed
        );
      } else {
        setLoadingText(response?.data?.message);
      }
    }
  };


  const retryPrevisit = async () => {
    setDisabledRetry(true);
    setIsDataLoaded(false);
    try {
      notify("success", "Retry send successfully.", 0.2)
      await getSignOutPatient(accountId, locationId, waitingId, true);
      setEnableRetry(false);
    } catch (error) {
      // console.log("🚀 ~ retryPrevisit ~ error:", error);
    } finally {
      setDisabledRetry(false);
    }
  };

  // const handleSignOutSheet = async (accountId, locationId, id) => {
  //   try {
  //     await updateSignOutSheet(accountId, locationId, id, true);
  //   } catch (error) {
  //     console.log("🚀 ~ handleSignOutSheet ~ error:", error);
  //   }
  // };

  const handleFilterConditions = (chronicConditions) => {
    const filteredData = chronicConditions?.reduce((acc, condition) => {
      const diseaseOrName = condition?.disease_name || condition?.name || "";

      if (
        !acc.some((c) =>
          c?.disease_name?.includes("Type 2 Diabetes") ||
          c?.name?.includes("Type 2 Diabetes")
        ) ||
        !diseaseOrName.includes("Type 2 Diabetes")
      ) {
        acc.push({
          ...condition,
          name: diseaseOrName.includes("Type 2 Diabetes")
            ? "Type 2 Diabetes"
            : diseaseOrName,
        });
      }
      return acc;
    }, []);
  
    setFilteredConditions(filteredData);
  };  

  const handlePrint = () => {
    window.print();
  };

  // const handleGoBack = () => {
  //   navigate(-1);
  // };
  const handleCloseWindow = () => {
    window.close();
    // if window.close() doesn't work, use navigate to go back to the /waiting-room page
    navigate("/waiting-room");
  };

  useEffect(() => {
    if (isDataLoaded && !retryPotentialAncillary) {
      // if(sheetType === 'print'){
      //   handlePrint();
      // } else if(sheetType === 'download'){
      if(sheetType === 'download'){
        downloadPdf();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDataLoaded, retryPotentialAncillary]);

  const downloadPdf = () => {
    if (isDataLoaded && !retryPotentialAncillary) {
      var patient = signOutPatientData && signOutPatientData.last_name && signOutPatientData.first_name ? `${signOutPatientData.last_name} ${signOutPatientData.first_name}` : "";
      var element =  document.querySelector('.docpro_signout');

      if (element) {
        element.querySelectorAll("textarea").forEach((textarea) => {
          const p = document.createElement("p");
          p.textContent = textarea.value;
          p.style.cssText = textarea.style.cssText;
          textarea.replaceWith(p);
        });

        element.querySelectorAll("input").forEach((input) => {
          const p = document.createElement("p");
          p.textContent = input.value;
          p.style.cssText = input.style.cssText;
          input.replaceWith(p);
        });

        var options = {
          margin: [8, 0, 8, 0],
          filename: `${patient} ${previsitDos} signout sheet.pdf`,
          image: { type: 'jpeg', quality: 0.10 },
          html2canvas: { scale: 4 },
          jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
        };

        html2pdf().from(element).set(options).save().then(() => {
          if(sheetType === 'download'){
            window.close();
          }
        });
      }
    }
  };

  useDocumentTitle("Previsit");

  return (
    <div ref={contentRef} className="docpro_signout_wrap small_page_wrap">
      <div className="docpro_signout relative docpro_full_height docpro_signout_previsit_print_document">
        {isDataLoaded ? (
          <>
            <div className="docpro_signout_header">
              <div>
                <div className="flex" style={{ alignItems: "start" }}>
                  <img
                    src={
                      signOutPatientData && signOutPatientData.sex === "M"
                        ? maleAvatar
                        : signOutPatientData && signOutPatientData.sex === "F"
                        ? femaleAvatar
                        : otherAvatar
                    }
                    alt=""
                    width={40}
                    height={40}
                    style={{
                      marginRight: "15px",
                      objectFit: "cover",
                      borderRadius: "50%",
                    }}
                  />
                  <div>
                    <h2 className="docpro_mb_0 docpro_fs_20 mb-1">
                      {signOutPatientData &&
                      signOutPatientData.last_name &&
                      signOutPatientData.first_name
                        ? `${signOutPatientData.last_name} ${signOutPatientData.first_name}`
                        : ""}
                    </h2>
                    {signOutPatientData &&
                      signOutPatientData?.risk_level === "High" && (
                        <span className="docpro_badge docpro_badge_red">
                          High-Risk Patient
                        </span>
                      )}
                    {signOutPatientData &&
                      signOutPatientData?.risk_level === "Moderate" && (
                        <span className="docpro_badge docpro_badge_orange">
                          Moderate-Risk Patient
                        </span>
                      )}
                    {signOutPatientData &&
                      signOutPatientData?.risk_level === "Low" && (
                        <span className="docpro_badge docpro_badge_green">
                          Low-Risk Patient
                        </span>
                      )}
                  </div>
                </div>
                <Spacing lg="15" sm="15" />
                <div>
                  <h4 className="docpro_mb_0 docpro_fs_16 mb-1">
                    Chronic Conditions
                  </h4>
                  <div>
                    {filteredConditions && filteredConditions.length > 0 && (
                      <div className="label_wrapper">
                        <label className="docpro_fw_400 docpro_primary_color docpro_lh_18">
                          {filteredConditions.map((item, index) => (
                            <span key={item.id} style={{ marginRight: "4px" }}>
                              {item.name}
                              {index !== filteredConditions.length - 1 && ", "}
                            </span>
                          ))}
                        </label>
                      </div>
                    )}
                  </div>
                </div>
                <Spacing lg="8" sm="8" />
              </div>

              <div style={{ minWidth: "55%" }}>
                <div className="docpro_signout_input cs_flex_1 mb-1 previsit_dos">
                  <label className="docpro_uppercase docpro_fw_600 docpro_primary_color">
                    DOS:
                  </label>
                  <input
                    type="text"
                    style={{ maxWidth: "100px" }}
                    defaultValue={previsitDos}
                  />
                </div>
                <div>
                  <p className="docpro_mb_0 mb-1">
                    <b>Gender: </b>
                    {signOutPatientData && signOutPatientData.sex
                      ? Gender(signOutPatientData.sex)
                      : ""}
                  </p>
                  <p className="docpro_mb_0 mb-1">
                    <b>Insurance: </b>
                    {signOutPatientData
                      ? signOutPatientData.insurance
                        ? signOutPatientData.insurance.name
                        : ""
                      : ""}
                  </p>
                  <p className="docpro_mb_0 mb-1">
                    <b>DOB: </b>
                    {signOutPatientData && signOutPatientData.dob
                      ? `${exchangeDate(
                          signOutPatientData.dob
                        )} (${calculateAgeFromDOB(
                          signOutPatientData.dob
                        )} years old)`
                      : ""}
                  </p>
                  <p className="docpro_mb_0 mb-1">
                    <b>Last annual wellness visit: </b>
                    {lastWellnessDate ? lastWellnessDate : ""}
                  </p>
                  <p className="docpro_mb_0 mb-1">
                    <b>Last hospitalization date: </b>
                    {signOutPatientData &&
                    signOutPatientData?.last_hospitalization_date
                      ? signOutPatientData?.last_hospitalization_date
                      : ""}
                  </p>
                </div>
              </div>
            </div>
            <div className="docpro_signout_top">
              <div className="docpro_visits">
                <div style={{ minWidth: "60%" }}>
                  <h4 className="docpro_mb_0 docpro_fs_16 mb-1">
                    Last 3 Visits Summary:
                  </h4>
                  <table className="docpro_singout_table visit table_previsit_print docpro_mb_0">
                    <tbody>
                      {Object.keys(lastThreeVisitData).length > 0 &&
                        Object.entries(lastThreeVisitData).map(
                          ([date, summary], index) => {
                            const adjustHeight = (e) => {
                              e.target.style.height = "auto";
                              e.target.style.height = `${e.target.scrollHeight}px`;
                            };

                            return (
                              <tr key={index}>
                                <td className="visit_date">
                                  <div className="docpro_signout_input visit">
                                    <input
                                      type="text"
                                      className="table_input"
                                      defaultValue={exchangeDate(date)}
                                    />
                                  </div>
                                </td>
                                <td>
                                  <div className="docpro_signout_input visit">
                                    <textarea
                                      className="table_input"
                                      defaultValue={summary}
                                      rows="1"
                                      onInput={adjustHeight}
                                      ref={(el) => {
                                        if (el) {
                                          el.style.height = "auto";
                                          el.style.height = `${el.scrollHeight}px`;
                                        }
                                      }}
                                    />
                                  </div>
                                </td>
                              </tr>
                            );
                          }
                        )}
                    </tbody>
                  </table>
                </div>
                <div style={{ minWidth: "40%" }}>
                  <h4 className="docpro_mb_0 docpro_fs_16 mb-1">
                    Today’s visit:
                  </h4>
                  <textarea
                    ref={todayTextareaRef}
                    cols="30"
                    rows="2"
                    className="signout_textbox"
                    value={todayText}
                    onChange={(e) => setTodayText(e.target.value)}
                  ></textarea>
                </div>
              </div>
              {retryPotentialAncillary && (
                <div
                  style={{
                    width: "100%",
                    height: "80px",
                    justifyContent: "center",
                    display: "grid",
                    alignContent: "center",
                  }}
                >
                  <span className="audit_report_loader"></span>
                </div>
              )}
              <Spacing lg="10" sm="10" />
              <div className="docpro_signout_tables">
                {[
                  "Screening_Codes",
                  "EM_Codes",
                  "Counseling_Codes",
                  "Procedure_Codes",
                  "HCC_Codes",
                ]
                  .filter(
                    (codeType) => ancillaryServices?.[codeType]?.length > 0
                  )
                  .map((codeType, index) => (
                    <React.Fragment key={index}>
                      <h4 className="docpro_mb_0 docpro_fs_16 mb-1">
                        {codeType.replace("_", " ")}:
                      </h4>
                      <div className="docpro_table_1">
                        <div
                          className="docpro_table_responsive docpro_pre_visit_table"
                          style={{ paddingBottom: 0 }}
                        >
                          <table
                            className="docpro_mb_0 table_print previsit_screening"
                            style={{ backgroundColor: "transparent" }}
                          >
                            <thead>
                              <tr>
                                <th>Service</th>
                                <th className="fixed_width">Codes</th>
                                <th className="fixed_width">Last use date</th>
                              </tr>
                            </thead>
                            <tbody>
                              {ancillaryServices[codeType].map(
                                (item, index) => {
                                  const adjustHeight = (e) => {
                                    e.target.style.height = "auto";
                                    e.target.style.height = `${e.target.scrollHeight}px`;
                                  };

                                  return (
                                    <tr key={index}>
                                      <td
                                        style={{ backgroundColor: "#FFFFFF" }}
                                      >
                                        <div className="docpro_signout_input">
                                          <textarea
                                            className="table_input"
                                            defaultValue={
                                              item?.service_name || ""
                                            }
                                            rows="1"
                                            onInput={adjustHeight}
                                            ref={(el) => {
                                              if (el) {
                                                el.style.height = "auto";
                                                el.style.height = `${el.scrollHeight}px`;
                                              }
                                            }}
                                            style={{ backgroundImage: "none" }}
                                          />
                                        </div>
                                      </td>
                                      <td
                                        style={{ backgroundColor: "#FFFFFF" }}
                                      >
                                        <div className="docpro_signout_input visit">
                                          <textarea
                                            className="table_input print_input"
                                            defaultValue={
                                              codeType === "Screening_Codes"
                                                ? item.screening_code
                                                : codeType === "EM_Codes"
                                                ? item.em_code
                                                : codeType ===
                                                  "Counseling_Codes"
                                                ? item.counseling_code
                                                : codeType === "Procedure_Codes"
                                                ? item.procedure_code
                                                : codeType === "HCC_Codes"
                                                ? item.hcc_code
                                                : ""
                                            }
                                            rows="1"
                                            onInput={adjustHeight}
                                            ref={(el) => {
                                              if (el) {
                                                el.style.height = "auto";
                                                el.style.height = `${el.scrollHeight}px`;
                                              }
                                            }}
                                            style={{ backgroundImage: "none" }}
                                          />
                                        </div>
                                      </td>
                                      <td
                                        style={{ backgroundColor: "#FFFFFF" }}
                                      >
                                        <div className="docpro_signout_input">
                                          <textarea
                                            className="table_input print_input"
                                            defaultValue={
                                              item?.dos
                                                ? exchangeDate(item.dos)
                                                : ""
                                            }
                                            rows="1"
                                            onInput={adjustHeight}
                                            ref={(el) => {
                                              if (el) {
                                                el.style.height = "auto";
                                                el.style.height = `${el.scrollHeight}px`;
                                              }
                                            }}
                                            style={{ backgroundImage: "none" }}
                                          />
                                        </div>
                                      </td>
                                    </tr>
                                  );
                                }
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <Spacing lg="10" sm="10" />
                    </React.Fragment>
                  ))}
              </div>
              <h4 className="docpro_mb_0 docpro_fs_16 mb-1">Pending QM:</h4>
              <div>
                {signOutPatientData?.care_gaps &&
                  signOutPatientData?.care_gaps.length > 0 && (
                    <div className="label_wrapper">
                      <label className="docpro_fw_400 docpro_primary_color docpro_lh_18">
                        {signOutPatientData?.care_gaps?.map(
                          (item, index) =>
                            item.status === "pending" && (
                              <span
                                key={index}
                                className="signout_pending_measure"
                              >
                                {item.name}
                              </span>
                            )
                        )}
                      </label>
                    </div>
                  )}
              </div>
              <Spacing lg="15" sm="15" />
              <div className="docpro_visits">
                <div
                  className="docpro_signout_input"
                  style={{ minWidth: "50%" }}
                >
                  <label className="docpro_fw_600 docpro_primary_color">
                    Specialist <br /> Referral:
                  </label>
                  <input type="text" />
                </div>
                <div
                  className="docpro_signout_input"
                  style={{ minWidth: "50%" }}
                >
                  <label className="docpro_fw_600 docpro_primary_color">
                    Imaging <br /> Referral:
                  </label>
                  <input type="text" />
                </div>
              </div>
              <Spacing lg="20" sm="20" />
              <div className="docpro_footer_textarea">
                <h4 className="docpro_mb_0 docpro_fs_16 mb-1">Note:</h4>
                <textarea
                  ref={noteTextareaRef}
                  cols="30"
                  rows="2"
                  className="signout_textbox"
                  value={noteText}
                  onChange={(e) => setNoteText(e.target.value)}
                ></textarea>
              </div>
            </div>
          </>
        ) : (
          <div
            className=" loading"
            style={{
              width: "100%",
              height: "80vh",
              justifyContent: "center",
              display: "grid",
              alignContent: "center",
            }}
          >
            <span className="audit_report_loader"></span>
            <p style={{ margin: "10px" }}>
              {loadingText ? loadingText : "Loading..."}
            </p>
            {enableRetry && (
              <div style={{ margin: "10px auto" }}>
                <button
                  className="docpro_bordered_btn docpro_fw_600 docpro_white_color docpro_filed_btn size_lg"
                  onClick={retryPrevisit}
                >
                  <RotateCw width={15} height={15} />
                  <span>Retry</span>
                </button>
              </div>
            )}
          </div>
        )}
      </div>

      {sheetType !== "download" && isDataLoaded && (
        <div className="docpro_invoice_btns docpro_hide_print">
          <button
            className="docpro_invoice_btn docpro_color3 close_button"
            onClick={handleCloseWindow}
          >
            <span className="docpro_btn_icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lucide lucide-x"
              >
                <path d="M18 6 6 18" />
                <path d="m6 6 12 12" />
              </svg>
            </span>
            <span className="docpro_btn_text">Close</span>
          </button>
          <button
            className="docpro_invoice_btn docpro_color1"
            onClick={handlePrint}
          >
            <span className="docpro_btn_icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="ionicon"
                viewBox="0 0 512 512"
              >
                <path
                  d="M384 368h24a40.12 40.12 0 0040-40V168a40.12 40.12 0 00-40-40H104a40.12 40.12 0 00-40 40v160a40.12 40.12 0 0040 40h24"
                  fill="none"
                  stroke="currentColor"
                  strokeLinejoin="round"
                  strokeWidth={32}
                />
                <rect
                  x={128}
                  y={240}
                  width={256}
                  height={208}
                  rx="24.32"
                  ry="24.32"
                  fill="none"
                  stroke="currentColor"
                  strokeLinejoin="round"
                  strokeWidth={32}
                />
                <path
                  d="M384 128v-24a40.12 40.12 0 00-40-40H168a40.12 40.12 0 00-40 40v24"
                  fill="none"
                  stroke="currentColor"
                  strokeLinejoin="round"
                  strokeWidth={32}
                />
                <circle cx={392} cy={184} r={24} fill="currentColor" />
              </svg>
            </span>
            <span className="docpro_btn_text">Print</span>
          </button>
          <button
            id="docpro_download_btn"
            className="docpro_invoice_btn docpro_color2"
            onClick={downloadPdf}
          >
            <span className="docpro_btn_icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="ionicon"
                viewBox="0 0 512 512"
              >
                <path
                  d="M320 336h76c55 0 100-21.21 100-75.6s-53-73.47-96-75.6C391.11 99.74 329 48 256 48c-69 0-113.44 45.79-128 91.2-60 5.7-112 35.88-112 98.4S70 336 136 336h56M192 400.1l64 63.9 64-63.9M256 224v224.03"
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={32}
                />
              </svg>
            </span>
            <span className="docpro_btn_text">Download</span>
          </button>
          {can_visit("administrator") && (
            <button
              type="button"
              id="docpro_download_btn"
              className="docpro_invoice_btn docpro_color1"
              onClick={retryPrevisit}
              disabled={disabledRetry ? true : false}
            >
              <span className="docpro_btn_icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="23"
                  height="23"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-rotate-cw"
                >
                  <path d="M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8" />
                  <path d="M21 3v5h-5" />
                </svg>
              </span>
              <span className="docpro_btn_text">Retry</span>
            </button>
          )}
        </div>
      )}
    </div>
  );
}
